/*
 *             Copyright (c) 2016 - 2022, CKSource Holding sp. z o.o. All rights reserved.
 *
 *
 *
 *
 *          +---------------------------------------------------------------------------------+
 *          |                                                                                 |
 *          |                                 Hello stranger!                                 |
 *          |                                                                                 |
 *          |                                                                                 |
 *          |   What you're currently looking at is the source code of a legally protected,   |
 *          |    proprietary software. Any attempts to deobfuscate / disassemble this code    |
 *          |               are forbidden and will result in legal consequences.              |
 *          |                                                                                 |
 *          |                                                                                 |
 *          +---------------------------------------------------------------------------------+
 *
 *
 *
 *
 */
const _0xfea0=['string','root','fields'];(function(_0x504cc4,_0xfea0cb){const _0x5f5098=function(_0x4dc6ac){while(--_0x4dc6ac){_0x504cc4['push'](_0x504cc4['shift']());}};_0x5f5098(++_0xfea0cb);}(_0xfea0,0x1b5));const _0x5f50=function(_0x504cc4,_0xfea0cb){_0x504cc4=_0x504cc4-0x0;let _0x5f5098=_0xfea0[_0x504cc4];return _0x5f5098;};import _0x51d300 from'./attributeoperationcompressor';export default class c extends _0x51d300{static get['description'](){const _0x535326=_0x51d300['description'];return delete _0x535326[_0x5f50('0x0')]['range'],_0x535326[_0x5f50('0x0')][_0x5f50('0x2')]={'type':_0x5f50('0x1'),'id':0x1},_0x535326;}}